// 회사소개 보강 콘텐츠. 배열이 비어 있으면 화면에는 "자료 준비 중" 안내가 표시된다.
// 연혁 페이지(회사 소개·연혁·대표이사 이력·디자인사업부)는 관리자 콘솔(/admin/company-history)에서 수정하며,
// 아래 값은 관리자가 아직 저장하지 않았을 때의 기본 문구다 (companyHistoryService.ts)
// 이미지는 client/src/screen/images/about/ 등에 넣고 import 해서 logo 값으로 지정한다.
// 인증서는 관리자 콘솔(/admin/certifications)에서 관리한다 (certificationService.ts)

// 제목이 붙은 항목 묶음 (연혁, 대표 이력 공통)
export interface ListGroup {
  label: string;
  items: string[];
}

export interface CeoProfile {
  name: string;
  title: string;
  career: ListGroup[];
}

export interface DesignService {
  title: string;
  desc: string;
}

// 회사 소개 문구
export const COMPANY_INTRO = {
  badges: ['사회적기업', '여성기업', '산업디자인전문회사', '옥외광고업 등록회사', '출판업 등록 회사'],
  text: [
    '디자인 전문기업 (주)지웍스는',
    '다양한 기관, 조직, 사회적경제기업과의 업무를 통한',
    '축적된 경험과 전문화된 퀄리티로',
    '고객에게 꼭 필요한 서비스를 제공해드립니다.',
  ],
};

// 회사 연혁 (최신순)
export const COMPANY_HISTORY: ListGroup[] = [
  {
    label: '디자인 · 제작',
    items: [
      '대구제2빙상장(대구공공시설관리공단) 브랜딩 개발 및 내외부 사인물 제작 및 시공',
      '대구광역시 달서구 사회적경제지원센터 내외부 사인물 및 디자인물 제작 진행',
      '경상북도 친환경관련기업 홍보 책자 기획, 디자인 및 제작 납품',
      '대구광역시 수성구 사회적경제기업 홍보 영상 제작',
    ],
  },
  {
    label: '지역 활성화 · 상품 개발',
    items: [
      '경상북도 청송군 달기약수탕 상권활성화 사업 진행',
      '전통시장진흥재단 골목활성화사업 진행',
      '경상북도 영천시 서부동 캐릭터 개발',
      '문경시 쌍용양회 캐릭터 용문이 용경이 개발',
      '대구광역시 북구 연암마을 관광상품 기획 개발 / 연비령, 연비참, 연비루',
      '경상북도 지역대학 상생협력사업(대구가톨릭대학교) 꿈바우 테마상품 포장/용기 개발',
    ],
  },
  {
    label: '행사 · 브랜딩',
    items: [
      '국토교통부 / 한국부동산원 주최 ‘소규모주택정비사업 아이디어 공모전’ 주관',
      '경상북도 울진군 ‘북적북적 북페스타’ 브랜딩 디자인 및 제작, 시공',
      '국립금오공과대학교 취업한마당 디자인물 진행',
      '경상북도 소상공인 비즈니스플랜 콘테스트 디자인 및 제작 시공',
      '경상북도사회적경제대상 전준한상식 메인 디자인 및 제작 시공납품',
      '대구광역시 「올해의책」, 「평생교육UP박람회」 디자인물 진행',
      '경상북도 「2022 경상북도 마을발전 포럼」 디자인물 진행',
      '정선로컬써밋 메인 브랜딩 디자인',
    ],
  },
  {
    label: '선정',
    items: [
      '한국관광공사 관광두레 컨설팅 업체 선정',
      '대구 사회적경제 우수기업 사회적기업 부문 선정',
      'SK SPC 선정 (사회성과인센티브)',
      '대구 청년 소셜벤처육성사업 아이비리그 선정',
      '디자인주도 제조혁신지원사업 컨설턴트',
    ],
  },
  {
    label: '협약',
    items: [
      '대구광역시 달서구 도시재생사업 TFT 협약 및 관련 디자인 및 제작진행',
      '느린 학습자(경계성 지능)를 위한 직무매뉴얼 개발 5자간 협약',
      '결혼이민여성 취업지원을 위한 4자간 협약',
      '여성 일자리 창출과 사회참여 활성화를 위한 협약',
      'DG글로벌창업포럼 설립 참여',
    ],
  },
  {
    label: '인증 · 설립',
    items: [
      '중소벤쳐기업부 지역기반 로컬 크리에이터 사업 선정(2021)',
      '볼빨간 사과빵 디자인 등록 (출원 번호 30-2020-0059732)',
      '산업 디자인 전문회사 지정 (신고확인증 번호: 제 11471 호)',
      '사회적기업 인증 (제2020-067호)',
      '여성기업 등록 / 중소기업 등록 / 옥외광고 사업 등록 / 출판사 등록',
      '고용노동부형 「예비 사회적기업」 지정 (제2018-073호)',
      '자체브랜드 「손수」 상표등록 (출원번호 40-2017-0087287)',
      '자체 브랜딩 플라워 베이커리 카페 ‘손수’ 오픈 및 운영',
      '「주식회사 지웍스」 법인 설립',
    ],
  },
];

// 대표이사 이력
export const CEO_PROFILE: CeoProfile = {
  name: '변수영',
  title: '대표이사',
  career: [
    {
      label: '학력',
      items: [
        '계명대학교 대학원 창업학과 박사과정 재학',
        '계명대학교 글로벌창업대학원 벤처창업학과 석사',
        '논문 <대구지역 여성기업 창업의 구조적특성과 지역맞춤형 육성방향 연구>',
      ],
    },
    {
      label: '현재',
      items: [
        '(주)지웍스 대표이사 (사회적기업 / 여성기업 / 산업디자인전문회사 / 옥외광고업 / 출판업)',
        '로코디랩 협동조합 이사',
        '비코 사회적협동조합 이사',
      ],
    },
    {
      label: '이전',
      items: [
        '(주) 커스프 이사 / 실장',
        '디자인앤컴퍼니 지웍스 대표',
        '에스프레소앤컴퍼니 대표',
        '핸즈커피(주.지핸즈) 실장',
        '(주) 지노 / 에이티디 매거진 안 아트디렉터',
        '하자 엔터테인먼트 디자이너',
        '디자인 TONG 디자이너',
      ],
    },
    {
      label: '보유이력 및 자격',
      items: [
        '한국관광공사 관광두레 디자인 컨설턴트(전)',
        '경상북도 상품개발 / 마케팅 컨설턴트',
        '디지털마케팅전문가 1급 / 생성형 AI 활용 기획전문가 1급',
        '로컬크리에이터 선정(중소벤처기업부 / 창업진흥원)',
        '대구청년소셜벤처 아이비리그 선정(대구창조경제혁신센터)',
        '인도네시아 발리 창업캠프 퍼실리테이터 참가(한국창업학회)',
        '대구시사회적기업협의회 이사 / 분과위원장(전)',
        '대구광역시 달서구 도시재생협력TFT',
        '한국보존화협회 숙빈회 1급강사 / 사범 이은희명인(한국보존화협회)',
        '아로마테라피스트 2급(국제아로마테라피협회) / 천연화장품/비누전문강사 1급(국제아로마테라피협회)',
        '프리저브드플라워 전문강사 (K-Lab) / 핸드크라프트 캔들전문가 (한국아로마테라피협회)',
        '컴퓨터그래픽스 운용기능사 (한국산업인력공단) / 커피바리스타전문가 (한국바리스타협회)',
      ],
    },
    {
      label: '주요 수행 사업',
      items: [
        '대구제2빙상장 브랜딩 및 내외부사인물 디자인 및 제작총괄',
        '경상북도 청송군 지역상권활성화 역량강화사업 수행',
        '대구광역시 북구 연암마을 관광상품 기획 및 개발, 생산',
        '대구광역시 협동조합 역량강화 지원사업 수행',
        '경상북도 지역대학 상생협력사업 대구가톨릭대학교 꿈바우 테마상품 패키지 개발사업 수행',
        '경상북도 문경 쌍용양회 캐릭터 및 굿즈 기획, 개발사업 수행',
        '경상북도 영천서부동 캐릭터 및 굿즈 기획, 개발사업 수행',
        '국토교통부/한국부동산원 주최 ‘소규모주택정비사업’ 아이디어 공모사업 총괄',
      ],
    },
    {
      label: '작품 · 출판 활동',
      items: [
        '대구광역시 북구 이태원길 공공미술 프로젝트 조형물 작품 설치',
        '제19회, 제20회 대구단편영화제 MOVIE&ART 독립만개 작품 참가',
        '수창청춘맨숀 조성 프로젝트 작품 설치',
        '출판_ [카페드유럽] 단행본 / 인물과사상사-북카라반',
        '장기연재_ 매거진 [커피앤티] / 아이비라인',
        '대구경북지역 문화매거진 [안] 아트디렉터 / 디자인 및 에디터',
      ],
    },
  ],
};

// 디자인사업부 업무 영역
export const DESIGN_SERVICES: DesignService[] = [
  { title: 'BRANDING', desc: 'BI _ CI _ 제품과 기업의 상징 및 브랜딩 일체' },
  { title: 'EDITORIAL DESIGN', desc: '포스터 _ 리플렛 _ 브로슈어 _ 현수막 등 오프라인 홍보물 전반' },
  { title: 'PACKAGE DESIGN', desc: '박스, 포장지, 띠지, 케이스 등 다양한 제품에 알맞은 패키지 디자인 및 제작일체' },
  { title: 'WEB DESIGN', desc: '웹포스터 _ 카드뉴스 _ 온라인 배너광고 등 온라인시대에 적합한 각종 디자인' },
  { title: 'MOVING DESIGN', desc: '영상물 및 동영상 기획 _ 디자인 _ 촬영 _ 편집 및 온라인 영상송출서비스 제공' },
  { title: 'SPACE DESIGN', desc: '행사 _ 이벤트 _ 프로젝트 _ 인테리어 _ VMD등 공간과 관련된 각종 디자인' },
  { title: 'PROMOTION', desc: '온라인 _ 오프라인 _ 광고서비스 대행' },
];
